export default "__VITE_ASSET__CRnfhaxY__"